const Dashboard = () => import('./components/Dashboard.vue')

export default {
  name: 'Dashboard',
  path: '',
  component: Dashboard
}
